import * as ko from 'knockout';

import { ListRequestParams } from '../api/request';
import { ListLoaderDelegate } from '../components/list_loader';
import * as customersProfilesApi from '../api/customer_profiles';

let template = require('raw-loader!../../templates/customer_profiles.html').default;

class CustomerProfilesScreen
  implements
    ListLoaderDelegate<customersProfilesApi.CustomerProfileData, customersProfilesApi.CustomerProfileData>
{
  fetch(params: ListRequestParams) {
    return customersProfilesApi.list(params);
  }

  instantiate(data: customersProfilesApi.CustomerProfileData) {
    return data;
  }

  remove(id: string) {
    return customersProfilesApi.remove(id);
  }

  canRemove(data: customersProfilesApi.CustomerProfileData) {
    return true;
  }
}

export let customerProfiles = {
  name: 'customer-profiles',
  viewModel: CustomerProfilesScreen,
  template: template,
};

ko.components.register(customerProfiles.name, customerProfiles);
